import { useState, useEffect, useCallback, useMemo } from 'react';

import Traductor from './Traductor';
import { isAppleDeviceOrNavegatorForDates } from '../Functions';
import useInterval from 'hooks/useInterval';

const CountDown = ({
    dateTime,
    isFinishedParent,
    options,
    dateExtended,
    serverTime,
    interval = 1000,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const [literal, setLiteral] = useState(t.getTraduction('Consultando'));
    const [currentDate, setCurrentDate] = useState();
    const [delay, setDelay] = useState(null);

    useEffect(() => {
        serverTime && setCurrentDate(+serverTime);
    }, [serverTime]);

    const reportIsFinished = useCallback(() => {
        setLiteral(t.getTraduction('Finalizada'));
        setDelay(null);
        if (isFinishedParent) isFinishedParent(true);
    }, [isFinishedParent, t]);

    const updateDate = useCallback(() => {
        if (!currentDate) return;
        let dateConversion = isAppleDeviceOrNavegatorForDates(dateTime);
        let countDownDate = new Date(dateConversion).getTime();
        let dateConversion2 = isAppleDeviceOrNavegatorForDates(dateExtended);
        let countDownDate2 = new Date(dateConversion2).getTime();
        let distance = new Date(countDownDate - currentDate).getTime();
        let distanceActualizadaExtended = new Date(
            countDownDate2 - currentDate
        ).getTime();
        var distanciaBase =
            distance > 0 ? distance : distanceActualizadaExtended;
        let days = Math.floor(distanciaBase / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
            (distanciaBase % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor(
            (distanciaBase % (1000 * 60 * 60)) / (1000 * 60)
        );
        let seconds = Math.floor((distanciaBase % (1000 * 60)) / 1000);
        if (seconds < 10) seconds = '0' + seconds;
        if (hours < 10) hours = '0' + hours;
        if (minutes < 10) minutes = '0' + minutes;
        let htmlCountDown = '';
        if (days > 0) {
            htmlCountDown =
                days +
                ' ' +
                (days === 1
                    ? t.getTraduction('Day')
                    : t.getTraduction('Days')) +
                ' ' +
                hours +
                ':' +
                minutes +
                ':' +
                seconds;
        } else {
            if (hours > 0) {
                htmlCountDown = hours + ':' + minutes + ':' + seconds;
            } else {
                if (minutes > 0) {
                    htmlCountDown = minutes + 'min ' + seconds + 's ';
                } else {
                    htmlCountDown = seconds + 's ';
                }
            }
        }
        setLiteral(htmlCountDown);
        if (distanceActualizadaExtended > 0 || distance > 0) {
            setLiteral(
                distance < 0 ? t.getTraduction('Extension') : htmlCountDown
            );
        } else {
            reportIsFinished();
        }

        if (distance < 0 && distanceActualizadaExtended < 0) {
            reportIsFinished();
        }

        setCurrentDate(currenValue => currenValue + delay);
    }, [currentDate, dateExtended, dateTime, delay, reportIsFinished, t]);

    useInterval(updateDate, delay);

    useEffect(() => {
        setDelay(interval);
        return () => setDelay(null);
    }, [dateTime, interval]);

    if (options) {
        let text = '';
        if (options.prevLabel) text += options.prevLabel;
        text += literal;
        if (options.nextLabel) text += options.prevLabel;
        return text;
    } else {
        return literal;
    }
};
export default CountDown;
